import React from "react";
import Page from "../Components/Page";
import { useParams } from "react-router-dom";
import useFetchData from "../hooks/useFetchData";
import { IUser } from "../features/users/types";
import UserForm from "../features/users/UserForm";
import { IControl } from "../features/controls/types";
import { DefaultLanguage } from "../contexts/LanguageProvider";
import { useTranslation } from "react-i18next";

const newEmptyUser: IUser = {
  id: -1,
  username: "",
  email: "",
  is_admin: false,
  is_operator: false,
  theme: "theme_teal",
  language: DefaultLanguage,
  last_seen: "",
  control_ids: [],
};

export const NewUserPage = () => {
  const { data: controls, isLoading } = useFetchData<IControl[]>("/controls");
  const { t } = useTranslation();
  return (
    <Page title={t("New User")} isLoading={isLoading}>
      {controls && <UserForm user={newEmptyUser} controls={controls} />}
    </Page>
  );
};

export const EditUserPage = () => {
  const params = useParams();
  const { data: user, isLoading: isUserLoading } = useFetchData<IUser>(
    `/users/${params.userid}`
  );
  const { data: controls, isLoading: isControlsLoading } =
    useFetchData<IControl[]>("/controls");
  return (
    <Page title={user?.username} isLoading={isUserLoading || isControlsLoading}>
      {user && controls && <UserForm user={user} controls={controls} />}
    </Page>
  );
};
